import React from "react";
import SbuxStyledTableRow from "../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../components/SbuxTable/SbuxStyledTableCell";
import { ellipse, getTitleForEllipse } from "../../../../utils/stringUtil";
import {
  QUEUE_METRICS_CALL_WAITING_WARNING_COUNT,
  QUEUE_METRICS_CALL_WAITING_THRSHOLD_COUNT,
} from "../../../../constants";
import { useAppSelector } from "../../../../store/types";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  selectCallsWaitingWarningThreshold,
  selectCallsWaitingErrorThreshold,
} from "../../../../selectors/userInstanceSelector";

interface MetricsRowProps {
  row: Record<string, unknown>;
}

const MetricsRow = ({ row }: MetricsRowProps) => {
  const callsWaitingWarningThreshold = useAppSelector(
    selectCallsWaitingWarningThreshold,
  );
  const callsWaitingErrorThreshold = useAppSelector(
    selectCallsWaitingErrorThreshold,
  );

  const callsWaitingWarningThresholdCount = callsWaitingWarningThreshold
    ? callsWaitingWarningThreshold
    : QUEUE_METRICS_CALL_WAITING_WARNING_COUNT;
  const callsWaitingErrorThresholdCount = callsWaitingErrorThreshold
    ? callsWaitingErrorThreshold
    : QUEUE_METRICS_CALL_WAITING_THRSHOLD_COUNT;

  const contactsInQueue = row.contactsInQueue as number;

  const displayIcons = () => {
    return (
      <div style={{ display: "flex" }}>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            paddingLeft: "40%",
          }}
        >
          {contactsInQueue}
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "20%",
          }}
        >
          {contactsInQueue >= callsWaitingWarningThresholdCount &&
          contactsInQueue < callsWaitingErrorThresholdCount ? (
            <WarningIcon sx={{ fontSize: "20px", color: "#f9a825" }} />
          ) : (
            contactsInQueue >= callsWaitingErrorThresholdCount && (
              <CancelIcon sx={{ fontSize: "20px", color: "#d32f2f" }} />
            )
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <SbuxStyledTableCell
          title={getTitleForEllipse(row.queueName as string | null | undefined)}
        >
          {ellipse(row.queueName as string | null | undefined)}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.agentsOnline as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.agentsAvailable as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.agentsOnContact as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.agentsAfterContactWork as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.agentsNonProductive as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell>{displayIcons()}</SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.oldestContactAge as React.ReactNode}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {row.contactsScheduled as React.ReactNode}
        </SbuxStyledTableCell>
      </SbuxStyledTableRow>
    </>
  );
};

export default MetricsRow;
